import React, { useState, useEffect, useRef } from "react";
import { View } from "react-native";
import { ScrollView, useColorMode } from "native-base";
import { useNavigation } from "@react-navigation/native";
import { StackNavigationProp } from "@react-navigation/stack";
import Api from "../../../Api/Api";
import { useTheme } from "../../../ThemeProvider";
import StorageUtil from "../../../Utils";
import Abertura from "../../components/Abertura/Index";
import {
  lerCacheAbertura,
  limparCacheAbertura,
  obterSubdominio,
  salvarCacheAbertura,
} from "../../components/Abertura/cacheAbertura";
import Layout1 from "./Layout1/Index";
import ModalConfirmacao from "../../../components/ModalConfirmacao";
import styles from "./styles";
import Layout2 from "./Layout2/Index";
import Layout3 from "./Layout3/Index";

const Inicio: React.FC = () => {
  const {
    primaryColor,
    isMobile,
    fontSizeMobile,
    fontSizeDesktop,
    setPrimaryColor,
    setCodEmpresa,
    setCodigoEmpresa,
    setIntervaloAgendamento,
    setBrindeAniversarianteMes,
    setLimiteAgendamentoFuturo,
    setDataLimiteAgendamentoFuturo,
    setConfigEmpresa,
    setMesAtual,
  } = useTheme();

  const navigation = useNavigation<StackNavigationProp<any>>();
  const refModal = useRef<any>(null);
  const refModalConfirmaLogin = useRef<any>(null);

  const [dados_empresa, setDados_empresa] = useState<any>([]);
  const [textoModal, setTextoModal] = useState<string>("");
  const [empresaNaoEncontrada, setEmpresaNaoEncontrada] =
    useState<boolean>(false);

  const [exibeBotaoAgendarPacote, setExibeBotaoAgendarPacote] =
    useState<boolean>(false);
  const [exibeLoader, setExibeLoader] = useState<boolean>(true);
  const [aindaCarregando, setAindaCarregando] = useState<boolean>(true);
  // marca salva na última visita (null na 1ª visita → abertura padrão)
  const [marcaAbertura] = useState(() => lerCacheAbertura());
  //  "#1976d2"

  const { colorMode, setColorMode } = useColorMode();

  useEffect(() => {
    getDadosEmpresa();

    let aberto = false;

    const timer = setTimeout(() => {
      clearTimeout(timer);

      if (!aberto) {
        aberto = true;
        validaLogin();
      }
    }, 500);

    const timerLoader = setTimeout(() => {
      clearTimeout(timerLoader);
      setExibeLoader(false);
    }, 2000);

    return () => {
      clearTimeout(timer);
      clearTimeout(timerLoader);
    };
  }, []);

  // foi colocado dentro desse useEffect porque quando a config utilizaPwaSimples
  // estava ativa, não estava esperando carregar para enviar para a tela de serviços
  useEffect(() => {
    const urlPagamentoOnline = window.location.href;

    if (
      dados_empresa &&
      (dados_empresa.utilizaPwaSimples || dados_empresa.utilizaLayoutV2) &&
      !aindaCarregando &&
      !exibeLoader
    ) {
      if (!dados_empresa.utilizaLayoutV2) {
        setTimeout(async () => {
          await StorageUtil.removeItem("cliente");
        }, 500);
      }
      console.log("vai verificar se é pagamento online");

      navigation.navigate("InicioStack", {
        screen: "Servicos",
        params: {
          logo: dados_empresa.logo,
          hideMessageAlerta: true,
        },
      });
    } else if (
      urlPagamentoOnline.indexOf("preencher-link-pagamento?hash=") > -1 &&
      dados_empresa &&
      !aindaCarregando &&
      !exibeLoader
    ) {
      navigation.navigate("InicioStack", {
        screen: "PagamentoOnline",
        params: {
          dados_empresa: dados_empresa,
        },
      });
    }
  }, [dados_empresa, aindaCarregando, exibeLoader]);

  async function getDadosEmpresa() {
    const subdomain = obterSubdominio();

    const getDadosEmpresa = await Api.dadosEmpresa(subdomain);

    if (!getDadosEmpresa.status) {
      limparCacheAbertura();
      setAindaCarregando(false);
      setEmpresaNaoEncontrada(true);
      setTimeout(() => {
        setTextoModal(
          getDadosEmpresa.error_details
            ? getDadosEmpresa.error_details.message
            : "Erro ao buscar dados da empresa ",
        );
        if (refModal.current) {
          refModal.current.abrirModal();
        }
      }, 3000);

      return;
    }

    if (getDadosEmpresa.data.intervaloAgendamento == 0) {
      setTextoModal("#001 - Não foi definido intervalo de agendamento");
      refModal.current.abrirModal();
      return;
    }

    //colocar no front exibeTempoServicoPWA

    setBrindeAniversarianteMes(getDadosEmpresa.data.brindeDeAniversario);
    setDados_empresa(getDadosEmpresa.data);
    setCodEmpresa(getDadosEmpresa.data.id);
    setCodigoEmpresa(getDadosEmpresa.data.codigo);
    setIntervaloAgendamento(getDadosEmpresa.data.intervaloAgendamento);
    setMesAtual(getDadosEmpresa.data.mesAtual);
    setLimiteAgendamentoFuturo(getDadosEmpresa.data.limiteAgendamentoFuturo);
    setDataLimiteAgendamentoFuturo(
      getDadosEmpresa.data.dataLimiteAgendamentoFuturo,
    );

    const urlParams = new URLSearchParams(window.location.search);
    let parametrosTeste = null;
    const encodedJsonString = urlParams.get("data");
    if (encodedJsonString) {
      const jsonString = decodeURIComponent(encodedJsonString);
      const coresTeste = JSON.parse(jsonString);
      if (coresTeste && coresTeste.length > 0) {
        parametrosTeste = coresTeste.reduce((acc: any, item: any) => {
          const key = Object.keys(item)[0];
          acc[key] = item[key];
          return acc;
        }, {});
      }
    }

    // atualiza a marca usada na abertura a cada carregamento, assim mudanças
    // de nome, logo ou cor da empresa já aparecem na próxima vez que abrir
    salvarCacheAbertura({
      nome: getDadosEmpresa.data.nomeFantasia || "",
      logo: getDadosEmpresa.data.logo || "",
      cor: getDadosEmpresa.data.corPrincipalEmpresa || "",
      legado: !!(
        getDadosEmpresa.data.utilizaPwaSimples ||
        getDadosEmpresa.data.utilizaLayoutV2 ||
        getDadosEmpresa.data.utilizaTemaEscuro
      ),
    });

    if (getDadosEmpresa.data.corPrincipalEmpresa) {
      setPrimaryColor(
        parametrosTeste
          ? parametrosTeste.corPrincipalEmpresa
          : getDadosEmpresa.data.corPrincipalEmpresa,
      );
    }
    console.log("dados...", getDadosEmpresa.data);

    setConfigEmpresa(
      JSON.stringify({
        permiteAgendarSemCadastro:
          getDadosEmpresa.data.permiteAgendarSemCadastro,
        utilizaPwaSimples: getDadosEmpresa.data.utilizaPwaSimples,
        exibeTempoServicoPWA: parametrosTeste
          ? parametrosTeste.exibeTempoServicoPWA
          : getDadosEmpresa.data.exibeTempoServicoPWA,
        exibeMenuSuperiorPWA: parametrosTeste
          ? parametrosTeste.exibeMenuSuperiorPWA
          : getDadosEmpresa.data.exibeMenuSuperiorPWA,
        ocultaBotoesRodapeServicos:
          getDadosEmpresa.data.ocultaBotoesRodapeServicos,
        naoSolicitarDadosCompletosPWA:
          getDadosEmpresa.data.naoSolicitarDadosCompletosPWA,
        validaDiasValidadePacote: getDadosEmpresa.data.validaDiasValidadePacote,
        utilizaTemaEscuro: getDadosEmpresa.data.utilizaTemaEscuro,
        // intervaloComTempoServico: getDadosEmpresa.data.intervaloComTempoServico,
        utilizaLayoutV2: getDadosEmpresa.data.utilizaLayoutV2,
        ocultarHorariosIndisponiveis:
          getDadosEmpresa.data.ocultarHorariosIndisponiveis,
        removerValidacaoTelefone: getDadosEmpresa.data.removerValidacaoTelefone,
        agendaPacotePeloPwa: getDadosEmpresa.data.agendaPacotePeloPwa,
        permiteVendaPacotePeloPwa:
          getDadosEmpresa.data.permiteVendaPacotePeloPwa,
        versaoPWA: getDadosEmpresa.data.utilizaLayoutV2 ? 2 : 1,
        coresPWA: parametrosTeste
          ? parametrosTeste
          : getDadosEmpresa.data.coresPWA,
        logo: getDadosEmpresa.data.logo,
        nomeFantasia: getDadosEmpresa.data.nomeFantasia,
        endereco: getDadosEmpresa.data.endereco,
      }),
    );
    setExibeBotaoAgendarPacote(getDadosEmpresa.data.botaoInicioAgPacote);

    if (getDadosEmpresa.data.utilizaTemaEscuro) {
      setColorMode("dark");
    }

    setAindaCarregando(false);
  }

  async function validaLogin() {
    const urlForceLogin = window.location.href.indexOf("forceLogin=true") > -1;
    if (urlForceLogin) {
      const value = await StorageUtil.getItem("cliente");
      if (!value || value.id <= 0) {
        //abre o modal avisando que precisa logar
        setTextoModal("Você precisa estar logado para continuar");
        refModalConfirmaLogin.current.abrirModal();
      }
    }
  }

  function renderViewLoader() {
    return <Abertura marca={marcaAbertura} />;
  }

  function renderViewConteudo() {
    return (
      <Layout3
        dados_empresa={dados_empresa}
        empresaNaoEncontrada={empresaNaoEncontrada}
        exibeBotaoAgendarPacote={exibeBotaoAgendarPacote}
        isMobile={isMobile}
        colorMode={colorMode}
        primaryColor={primaryColor}
      />
    );
  }

  return (
    <ScrollView>
      {exibeLoader || aindaCarregando
        ? renderViewLoader()
        : renderViewConteudo()}

      <ModalConfirmacao
        titulo={"Atenção"}
        ref={refModalConfirmaLogin}
        mensagem={textoModal}
        textoBotaoPositivo={"OK"}
        onConfirmPositivo={() => {
          if (refModalConfirmaLogin.current) {
            refModalConfirmaLogin.current.fecharModal();
            navigation.navigate("TabNavigator", {
              screen: "Login",
              params: {
                retornaLogin: true,
              },
            });
          }
        }}
      />
    </ScrollView>
  );
};

export default Inicio;
